var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulletin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 250
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 51, 10)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 135.432,
    width: 200,
    height: 207.769,
    style: {
      fill: "rgb(251, 251, 251)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 345.398,
    rx: 100,
    ry: 35.398,
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 265.126,
    width: 200,
    height: 72.254,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 345.342,
    rx: 100,
    ry: 35.398,
    style: {
      strokeWidth: 1,
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 264.602,
    rx: 100,
    ry: 35.398,
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 195.401,
    width: 200,
    height: 72.254,
    style: {
      fill: "rgb(255, 255, 255)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 257.356,
    rx: 100,
    ry: 35.398,
    style: {
      strokeWidth: 1,
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 198.813,
    rx: 100,
    ry: 35.398,
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 191.511,
    rx: 100,
    ry: 35.398,
    style: {
      strokeWidth: 1,
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 138.847,
    rx: 100,
    ry: 40.977,
    style: {
      strokeWidth: 1,
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 136.746,
    rx: 91.867,
    ry: 35.46,
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.447,
    cy: 439.17,
    r: 32.178,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.249,
    cy: 38.994,
    r: 32.178,
    style: {
      fill: "rgb(255, 255, 255)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.653,
    cy: 381.7,
    r: 32.178,
    style: {
      fill: "rgb(255, 255, 255)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.837,
    cy: 108.762,
    r: 32.178,
    style: {
      fill: "rgb(255, 255, 255)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.71,
    cy: 247.398,
    r: 32.178,
    style: {
      fill: "rgb(255, 255, 255)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.426,
    cy: 116.79,
    r: 32.178,
    style: {
      fill: "rgb(255, 255, 255)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -4.788,
    cy: 248.87,
    r: 32.178,
    style: {
      fill: "rgb(255, 255, 255)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.212,
    cy: 378.87,
    r: 32.178,
    style: {
      fill: "rgb(255, 255, 255)",
      strokeWidth: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletin);
export default __webpack_public_path__ + "static/media/bulletin.2b42e94ec767494ec069a9e238b512d2.svg";
export { ForwardRef as ReactComponent };